import type { PropsWithChildren } from 'react';

import { Typography } from '@capsule/consumer-design-system';

import { Container, Title } from './styles';

export interface DevOnlyProps extends PropsWithChildren<{ className?: string }> {}

export const DevOnly = ({ children, className }: DevOnlyProps) => {
  if (process.env.NEXT_PUBLIC_CAPSULE_ENV === 'production') return null;

  return (
    <Container data-testid="container" className={className}>
      <Title>Dev Only</Title>
      <Typography variant="body">{children}</Typography>
    </Container>
  );
};
